import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  query,
  stagger,
  animateChild,
  group
} from '@angular/animations';
import moment from 'moment';

@Component({
  selector: 'app-job-dialog-box',
  standalone: true,
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    CommonModule
  ],
  templateUrl: './job-dialog-box.component.html',
  styleUrl: './job-dialog-box.component.scss',
  animations: [
    // Animation for save button state
    trigger('saveButtonState', [
      state('invalid', style({
        opacity: 0.7,
        backgroundColor: '#9fa8da'
      })),
      state('valid', style({
        opacity: 1,
        backgroundColor: '#3f51b5'
      })),
      transition('invalid => valid', [
        animate('0.3s ease-in-out')
      ])
    ]),

    // Animation for form fields when appearing
    trigger('formFieldAnimation', [
      transition(':enter', [
        query('.form-group', [
          style({ opacity: 0, transform: 'translateY(20px)' }),
          stagger(100, [
            animate('0.5s ease', style({ opacity: 1, transform: 'translateY(0)' }))
          ])
        ], { optional: true })
      ])
    ]),

    // Animation for sensor fields
    trigger('sensorFieldAnimation', [
      transition(':enter', [
        style({ opacity: 0, height: 0, overflow: 'hidden' }),
        animate('0.3s ease', style({ opacity: 1, height: '*' }))
      ]),
      transition(':leave', [
        style({ opacity: 1, height: '*' }),
        animate('0.3s ease', style({ opacity: 0, height: 0 }))
      ])
    ]),

    // Animation for the container of sensor fields
    trigger('sensorListAnimation', [
      transition('* => *', [
        query('@sensorFieldAnimation', stagger(80, animateChild()), { optional: true })
      ])
    ])
  ]
})
export class JobDialogBoxComponent implements OnInit {
  public jobform: FormGroup;
  originalValues: any;
  formChanged=false;  

  public sensorControls: { index: number }[] = [];
  public ovenBaseUrl = BaseUrlConstantsService.OVEN_BASE_URL;
  public jobId: number;
  public clientId: string;
  public ovenId: number;
  public job_no : any;
  public role = localStorage.getItem("role");
  available_sensors=[];
  updated_sensors=[];
  jobTitle: string;
  meggerCheck: boolean = true;
  subsystemId: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private fb: FormBuilder,
    public service: BackendApiService,
    public dialogRef : MatDialogRef<JobDialogBoxComponent>,

  ) {
    if(this.role === "ADMIN"){



      this.clientId = localStorage.getItem("admin_client_id");
    }else{
      this.clientId = localStorage.getItem("user_id");
    }
    this.jobform = this.fb.group({
      JOB_NO: new FormControl('', [Validators.required]),
      no_of_sensor: new FormControl(null, [Validators.required, Validators.min(1),
        Validators.max(3)]),
      start_date: new FormControl('', [Validators.required]),
      end_date: new FormControl(null),
      megger_value: new FormControl(0,  [
        Validators.pattern(/^\d*\.?\d+$/),Validators.required
      ]),
      supervisor_name: new FormControl('', [Validators.required]),
      PI_value: new FormControl('0',  [
        Validators.pattern(/^\d*\.?\d+$/)
      ]),
      comment: new FormControl('', [Validators.required]),
      sensor_serial_no_1_value:new FormControl(''),
      sensor_serial_no_2_value:new FormControl(''),
      sensor_serial_no_3_value:new FormControl('')
      // Sensor fields will be added dynamically
    });

    if(this.data.type === 'createjob'){
      this.meggerCheck = true;
       this.jobform.get('megger_value')?.disable();
      this.jobTitle = "Create";
      this.ovenId = this.data.oven_id;
    }else if(this.data.type === 'editjob'){
      console.log(this.data)
      this.jobTitle = "Edit";
      this.jobform.get('megger_value')?.enable();
      this.meggerCheck = false;
      this.jobId = this.data.jobId;
      this.ovenId = this.data.oven_id;
      this.subsystemId = this.data.subsystem_id;
      this.getAvailableSensors().then(()=>{
        this.EditJobData();
      }).catch(()=>{
        this.EditJobData();
      })
    }else{
      this.job_no=this.data.JOB_NO  ;
    }
    console.log(this.jobId,'jobId');

  }

  ngOnInit() {
    // Listen to changes on the no_of_sensor field
    this.getAvailableSensors()
    this.jobform.get('no_of_sensor')?.valueChanges.subscribe((value) => {
      if(value>3) value = 3;
      this.updateSensorFields(value);
    });
  }

  updateSensorFields(count: string | number) {
    // Remove existing sensor fields
    this.sensorControls.forEach((_, index) => {
      this.jobform.removeControl(`sensor_serial_no_${index+1}`);
    });

    // Reset the sensor controls array
    this.sensorControls = [];

    // Add the appropriate number of sensor fields
    const sensorCount = typeof count === 'string' ? parseInt(count) || 0 : count || 0;
    for (let i = 0; i < sensorCount; i++) {
      this.jobform.addControl(
        `sensor_serial_no_${i+1}`,
        new FormControl('', [Validators.required])
      );
      this.sensorControls.push({ index: i });
      this.updated_sensors=this.available_sensors;
    }
  }

  onSubmit() {
    if (this.jobform.valid) {
      if(this.data.type === 'createjob'){
        const formData = this.jobform.value;
        // Create a sensors array from the dynamic fields
        const sensors = this.sensorControls.map((control, index) => {
          return {
            serial_no: formData[`sensor_serial_no_${index+1}`]
          };
        });
        let selected_temp_coil_1=this.available_sensors.filter(s=>s.serial_number==formData.sensor_serial_no_1)[0]?.metric_name
        let selected_temp_coil_2=this.available_sensors.filter(s=>s.serial_number==formData.sensor_serial_no_2)[0]?.metric_name
        let selected_temp_coil_3=this.available_sensors.filter(s=>s.serial_number==formData.sensor_serial_no_3)[0]?.metric_name

        if(formData.sensor_serial_no_1) formData.sensor_serial_no_1_value=this.data.coil_values.filter(g=>g.key==selected_temp_coil_1)[0].value
        if(formData.sensor_serial_no_2) formData.sensor_serial_no_2_value=this.data.coil_values.filter(g=>g.key==selected_temp_coil_2)[0].value
        if(formData.sensor_serial_no_3) formData.sensor_serial_no_3_value=this.data.coil_values.filter(g=>g.key==selected_temp_coil_3)[0].value
        // Create the final data structure
        const result = {
          ...formData,
          sensors
        };
        // Remove individual sensor fields from result
        this.sensorControls.forEach((_, index) => {
          delete result[`sensor_serial_no_${index+1}`];
        });

        // Return form data to the component that opened the dialog
        this.dialogRef.close(result);
      }else if(this.data.type == 'editjob'){
        this.jobform.value["oven_id"] = this.ovenId;
        this.jobform.value["client_id"] = this.clientId;
        let comment_type = "job-comment";
        const formData = { ...this.jobform.value, job_id: this.jobId, comment_type: 'job-comment', subsystem_id: this.subsystemId };
        console.log(formData, 'value');
        this.service.putData(`${this.ovenBaseUrl}api/v1/oven-assets/jobs/update/${this.clientId}/${this.job_no}`,formData)
        // this.service.putData(`http://localhost:3024/api/v1/oven-assets/jobs/update/${this.clientId}/${this.job_no}`,formData)
        .then((response:any) =>{
          console.log(response,'response');
          if(response.code == '200'){
            this.dialogRef.close(response);
          }
        });
      }
      // Prepare form data for submission

    } else {
      // Mark all fields as touched to trigger validation messages
      this.markFormGroupTouched(this.jobform);
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  // Helper method to mark all controls in a form group as touched
  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  EditJobData() {
    this.service.getData(
      `${this.ovenBaseUrl}api/v1/oven-assets/jobs/details/${this.clientId}/${this.ovenId}/${this.jobId}`
      // `http://localhost:3024/api/v1/oven-assets/jobs/details/${this.clientId}/${this.ovenId}/${this.jobId}`
    ).then((response:any) => {
      if (!response || response.code !== 200) {
        console.error('Failed to fetch job data:', response?.message || 'Unknown error');
        return;
      }

      const job = response.data?.[0];

      if (!job) {
        console.warn('No job data found.');
        return;
      }
      this.job_no = job.JOB_NO;
      const startDate = job.start_date
  ? moment(job.start_date).local().format('YYYY-MM-DD HH:mm:ss')
  : '';
      // const end_date = job.end_date ? job.end_date.split('T')[0] : '';
      this.jobform.patchValue({
        JOB_NO: job.JOB_NO,
        no_of_sensor: job.no_of_sensor,
        start_date: startDate,
        end_date : null,
        megger_value : job.megger_value,
        PI_value : job.PI_value,
        sensor_serial_no_1: job.sensor_serial_no_1,
        sensor_serial_no_2: job.sensor_serial_no_2,
        sensor_serial_no_3: job.sensor_serial_no_3,
        supervisor_name: job.supervisor_name,
        comment: job.comment,
      });
        let formData=this.jobform.getRawValue();
        let selected_temp_coil_1=job?.sensor_serial_no_1_key
        let selected_temp_coil_2=job?.sensor_serial_no_2_key
        let selected_temp_coil_3=job?.sensor_serial_no_3_key
        if(formData.sensor_serial_no_1) formData.sensor_serial_no_1_value=this.data.coil_values.filter(g=>g.key==selected_temp_coil_1)[0].value
        if(formData.sensor_serial_no_2) formData.sensor_serial_no_2_value=this.data.coil_values.filter(g=>g.key==selected_temp_coil_2)[0].value
        if(formData.sensor_serial_no_3) formData.sensor_serial_no_3_value=this.data.coil_values.filter(g=>g.key==selected_temp_coil_3)[0].value
        this.jobform.patchValue({
          sensor_serial_no_1_value:formData.sensor_serial_no_1_value,
          sensor_serial_no_2_value:formData.sensor_serial_no_2_value,
          sensor_serial_no_3_value:formData.sensor_serial_no_3_value,

        })
        // console.log("sensor_serial_no_3_value", formData.sensor_serial_no_3_value)
      this.originalValues = { ...this.jobform.value };
      // console.log(this.jobform,"---------------=================----------------")
      this.jobform.valueChanges.subscribe(val => {
      this.formChanged = JSON.stringify(val) !== JSON.stringify(this.originalValues) && JSON.stringify(val) !=='';
    });

    }).catch(error => {
      console.error('API call failed:', error);
    });
  }
  deleteJobData(){
    this.service.deleteInfo(`${this.ovenBaseUrl}api/v1/oven-assets/jobs/delete/${this.clientId}/${this.job_no}`)
    // this.service.deleteInfo(`http://localhost:3024/api/v1/oven-assets/jobs/delete/${this.clientId}/${this.job_no}`)
    .then((resolve:any) =>{
      console.log(resolve)
      if(resolve.code === 200){
        this.dialogRef.close(resolve);
      }else{
        this.dialogRef.close();
      }
    })
  }

  getAvailableSensors(){
      return new Promise((resolve,reject)=>{
        this.service.getDataV2(`${this.ovenBaseUrl}/api/v1/oven-assets/get-available-sensors/${this.clientId}/${this.ovenId}`).then((data:any)=>{
      // this.service.getDataV2(`http://localhost:3024/api/v1/oven-assets/get-available-sensors/${this.clientId}/${this.ovenId}`).then((data:any)=>{
        this.available_sensors=data.data;
        this.updated_sensors=this.available_sensors
        resolve('')
      }).catch(err=>{
        console.log(err)
        reject('')
      })
      })
  }
}
